import { useReducer } from "react";
import { contextFactory } from "@wff/context/helpers/contextFactory";
import { PRODUCTS_LISTING_FILTER_INITIAL_STATE } from "../constants";
import { IProductsFilterState } from "../types";
import { actionCreators, productsFilterReducer } from "./productsFilterReducer";

interface ProductsFilterProps extends IProductsFilterState {
  query?: string;
  dispatch: React.Dispatch<any>;
  resetFilter: () => void;
  setActiveDropdownFilter: (activeDropdownFilter: number | undefined) => void;
  setFilter: (filter: Partial<IProductsFilterState>) => void;
  setFilterValues: (filter: { category: string; value: string }) => void;
  setSelectedNavigation: (selectedNavigation: string) => void;
  setSortBy: (sortBy: string | undefined) => void;
  toggleMobileDrawerMenu: () => void;
  toggleNavigation: () => void;
}

const [useProductsFilter, ProductsFilterContext] =
  contextFactory<ProductsFilterProps>();

export { useProductsFilter, ProductsFilterContext };

interface FilterProviderProps {
  children: React.ReactNode;
}

export const ProductsFilterProvider = (props: FilterProviderProps) => {
  const [state, dispatch] = useReducer(productsFilterReducer, {
    ...PRODUCTS_LISTING_FILTER_INITIAL_STATE,
  });

  const toggleNavigation = () => {
    dispatch(actionCreators.toggleNavigation());
  };

  const setActiveDropdownFilter = (filter: number | undefined) => {
    dispatch(actionCreators.setActiveDropdownFilter(filter));
  };

  const toggleMobileDrawerMenu = () => {
    dispatch(actionCreators.toggleMobileDrawerMenu());
  };

  const setFilter = (filter: Partial<IProductsFilterState>) => {
    dispatch(actionCreators.setFilter(filter));
  };

  const setFilterValues = (filter: { category: string; value: string }) => {
    dispatch(actionCreators.setFilterValues(filter));
  };

  const setSortBy = (sortBy: string | undefined) => {
    dispatch(actionCreators.setSortBy(sortBy));
  };

  const setSelectedNavigation = (selectedNavigation: string) => {
    dispatch(actionCreators.setSelectedNavigation(selectedNavigation));
  };

  const resetFilter = () => {
    dispatch(actionCreators.resetFilter());
  };

  return (
    <ProductsFilterContext.Provider
      value={{
        ...state,
        dispatch,
        setFilter,
        resetFilter,
        setSortBy,
        setFilterValues,
        setSelectedNavigation,
        toggleMobileDrawerMenu,
        setActiveDropdownFilter,
        toggleNavigation,
      }}
    >
      {props.children}
    </ProductsFilterContext.Provider>
  );
};
